import React from 'react';
import classNames from 'classnames';
import styles from './shot-map-goal-view.module.scss';
import {Image} from "../../image/image";
import {PenaltiesGoalRequestParams} from "../../../icons/images/penalties/penalties.goal.request-params";
import {observer} from "mobx-react";

export const ShotMapGoalViewGoal = observer(({width, height}) => {
  if(!width > 0){
    return null;
  }

  const imageProps = {
    className: classNames(styles.goal_frame),
    src: new PenaltiesGoalRequestParams({width, height}),
    style: {width, height},
  }

  return <Image {...imageProps}/>
})
